export const LIST_ITEM_HEIGHT = 48
